import React, { Component } from 'react'
import { Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'
import { hostname } from '../../settings'

import parcel from '../../assets/parcel.png'
import truck from '../../assets/truck.png'
import coins from '../../assets/coins.png'
import clock from '../../assets/clock.png'

const boxStyle = { backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', display: 'flex', borderRadius: 20, padding: 20, paddingTop: 30, marginTop: 40, boxShadow: "grey 1px 1px 5px" }

class KPIContainer extends Component {
    constructor(p) {
        super(p)

        this.state = { deliveryTimeSave: {} }

    }

    render() {
        const { deliveryQty, deliveryOccasionsQty } = this.props


        const timeSave = deliveryOccasionsQty * 20 / 60
        const costSave = timeSave * 700

        return (
            <Grid fluid>
                <Row className="justify-content-center">
                    <Col xs={12} sm={3}>
                        <div style={boxStyle}>
                            <img style={{ width: 60 }} src={truck} alt="truck"/>
                            <h4>Totalt antal leveranser</h4>
                            <div style={{ color: '#006E78', fontWeight: 'bold' }}>{deliveryOccasionsQty}</div>
                        </div>
                    </Col>
                    <Col xs={12} sm={3}>
                        <div style={boxStyle}>
                            <img style={{ width: 60 }} src={parcel} alt="parcel"/>
                            <h4>Totalt antal kollin</h4>
                            <div style={{ color: '#006E78', fontWeight: 'bold' }}>{deliveryQty}</div>
                        </div>
                    </Col>
                    <Col xs={12} sm={3}>
                        <div style={boxStyle}>
                            <img style={{ width: 60 }} src={coins} alt="truck"/>
                            <h4>Kostnadsbesparing</h4>
                            <div style={{ color: '#006E78', fontWeight: 'bold' }}>{`${Math.round(costSave).toLocaleString('sv')} kr`}</div>
                        </div>
                    </Col>
                    <Col xs={12} sm={3}>
                        <div style={boxStyle}>
                            <img style={{ width: 60 }} src={clock} alt="truck"/>
                            <h4>Tidsbesparing</h4>
                            <div style={{ color: '#006E78', fontWeight: 'bold' }}>{`${Math.round(timeSave).toLocaleString('sv')} h`}</div>
                        </div>
                    </Col>
                </Row>
            </Grid>
        )
    }
}

const mapProps = state => {
    return {
    }
}

const mapDispatch = dispatch => {
    return {}
}

export default connect(mapProps, mapDispatch)(KPIContainer)